import AsyncSelect from 'Shared/components/AsyncSelect'
import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'

function EffortShortDescriptor({ complete, effortName }) {
  return (
    <div>
      {complete && <div>
        <p className='no-margin-bottom'>This dashboard is part of the <b>{effortName}</b> goal.</p>
      </div>}
      {!complete && <p className='incomplete no-margin-bottom'>(Optional) Select a goal that this dashboard is working toward.</p>}
    </div>
  )
}

const Effort = () => {
  const act = useAct()

  const {
    effort: { id, name } = {}
  } = useSel(s => s.dashboard)

  const complete = !!name

  const updateEffort = (e, objs) => {
    act.dashboard.upsert({
      effortId: e,
      effort: { id: e, name: objs?.label },
    })
  }

  const clearEffort = () => {
    updateEffort(null, null)
  }

  function save() {
    return act.builder.save('effort').then(() => {
      act.builder.closeEditor()
    })
  }

  return <Step
    name='Goal'
    editor='effort'
    complete={complete}
    save={save}
    shortDescriptor={<EffortShortDescriptor complete={complete} effortName={name} />}
  >
    <div className='row'>
      <div className='column two-thirds'>
        <div className='field'>
          <label>Goal</label>
          <AsyncSelect
            entity='effort'
            value={id}
            loadStaticList={true}
            queryParameters={{ kept: 1 }}
            onChange={updateEffort}
            classNamePrefix="effort-select"
          />
        </div>
        {id && <>
          <a href="#" onClick={clearEffort} className="blue-link">Clear</a>
        </>}
      </div>

      <div className='column third'>
        <p className='no-margin-top'>
          Goals optionally let you organise dashboards into long-running organisational initiatives.
          For example, a dashboard might be part of an 'Indicative strike ballot' goal.
        </p>
      </div>
    </div>
  </Step>
}

export default Effort
